export default function compareDates(
  firstDate: Date,
  secondDate: Date,
  comparisonFn = (a, b) => a > b,
) {
  const d1 = new Date(firstDate);
  d1.setHours(0, 0, 0, 0);
  const d2 = new Date(secondDate);
  d2.setHours(0, 0, 0, 0);
  return comparisonFn(d1, d2);
}
